import React, { useEffect, useState, useCallback } from 'react';
import {
  TableNavigation,
  Button,
  Table,
  withForm,
} from '@casanova/casanova-common';
import columns, { contextualMenu, getCatalogContextualMenu } from './columns';
import { transformDropdownElements } from 'utils/transformHelpers';
import { config } from './config';
import i18n from '@i18n';
import _isEmpty from 'lodash/isEmpty';
import { useStateWithCallbackLazy } from 'use-state-with-callback';
import { FORM_ACTIONS } from 'utils/constants/formActions';
import BrandModal from '../modals/BrandModal';
import { CREATE_CATALOG_BRAND } from 'utils/roles/permissions/catalogsPermissions';
import { RoleVerifier } from 'components';

const Brand = ({
  fetchCatalogTable,
  listBrands,
  loader,
  onUpdateForm,
  setCatalogPage,
  type = 'brand',
}) => {
  const { content, params } = listBrands;

  const [action, setAction] = useStateWithCallbackLazy(FORM_ACTIONS.EDIT);
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleDropdownSelect = useCallback(
    (section) => {
      const { name = '', uuid = '' } = section;
      switch (name) {
        case (contextualMenu.EDIT, name):
          const brand = content.find((b) => b.uuid === uuid);
          setAction(FORM_ACTIONS.EDIT);
          setSelectedBrand(brand);
          setIsModalOpen(true);
          break;
        default:
          break;
      }
    },
    [content]
  );

  const handleModalClose = () => {
    setIsModalOpen(false);
    setSelectedBrand(null);
  };

  const handleSuccess = () => {
    setIsModalOpen(false);
    setSelectedBrand(null);
    fetchCatalogTable({ type, params });
  };

  useEffect(() => {
    fetchCatalogTable({ type, params });
  }, [fetchCatalogTable, type, params]);

  useEffect(() => {
    if (!_isEmpty(params)) {
      onUpdateForm({ ...params, type });
    }
  }, [onUpdateForm]);

  const handleAddClick = useCallback(() => {
    setAction(FORM_ACTIONS.ADD);
    setIsModalOpen(true);
  }, [history]);

  return (
    <>
      <BrandModal
        action={action}
        type={type}
        show={isModalOpen}
        setShow={setIsModalOpen}
        onClose={handleModalClose}
        onSuccess={handleSuccess}
        selectedBrand={selectedBrand}
      />
      <div>
        <Table
          additionalHeader
          rowClassName="row-clickable"
          emptyMessage="No se encontraron marcas"
          dataList={content}
          columns={columns.map((col) => ({
            ...col,
            renderer: (props = { data: {} }) => {
              const { status } = props.data;
              const Component = col.renderer;
              return (
                <Component
                  {...props}
                  dropdownOptions={transformDropdownElements({
                    elements: getCatalogContextualMenu(),
                  })}
                />
              );
            },
          }))}
          dropdownCell
          dropdownOptions={transformDropdownElements({
            elements: getCatalogContextualMenu(),
          })}
          onDropdownSelect={handleDropdownSelect}
          loading={loader}
        />
        <div className="row">
          <div className="col-12 col-xl-7 table-paginator text-right d-flex justify-content-between align-items-center">
            <TableNavigation
              search={listBrands}
              onChange={(page) => setCatalogPage({ type, page })}
            />
          </div>
          <div className="col-12 col-md-8 col-xl-5">
            <RoleVerifier identifier={CREATE_CATALOG_BRAND}>
              <Button block onClick={handleAddClick}>
                {i18n('COMMONS__NEW')}
              </Button>
            </RoleVerifier>
          </div>
        </div>
      </div>
    </>
  );
};

export default withForm({ config })(Brand);
